import TransitApi from './base'

export default {
  // TODO: Add search, filters and sort params
  async getPieRegularVariation(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(
        `/dashboard/get-pie-invoices-regular-vs-variations?${queryString}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // TODO: Add search, filters and sort params
  async getPieCreateDelivered(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(
        `/dashboard/get-pie-invoices-created-vs-delivered?${queryString}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getBarCreateDelivered(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(
        `/dashboard/get-bar-created-vs-delivered?${queryString}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getBarInvoices(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/dashboard/get-bar-invoices?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getLogs() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/dashboard/get-logs`)
      return result.data
    } catch (error) {
      return error.response
    }
  },
}
